const AwaitPayment = ({ paymentAuth, institution }) => (
  <div className="flex flex-col items-center gap-6 mt-8">
    <img
      className="size-[200px]"
      src={paymentAuth.paymentQRUrl}
      alt="paymentUrl"
    />
    <p className="text-center font-semibold text-lg">
      Scan the QR code to complete the transaction using your mobile banking app
    </p>
    <p className="text-center">Alternatively</p>
    <a
      href={paymentAuth.paymentUrl}
      target="_blank"
      rel="noreferrer noopener"
      className="flex w-full justify-center gap-2 border border-zinc-200 hover:border-primary py-3 px-5 items-center rounded-lg mt-8 shadow-sm"
    >
      <img
        className="size-8"
        src={institution.iconUrl}
        alt={institution.name}
      />
      <span className="text-sm">Continue online at {institution.name}</span>
    </a>
  </div>
);

export default AwaitPayment;
